import React from "react";
import Navbar from "../components/_App/Navbar1";
import PageBanner from "../components/Common/PageBanner";
import Link from "next/link";
import SubscribeForm from "../components/Common/SubscribeForm";
import Footer from "../components/_App/Footer";

const Categories = ({ dataNav }) => {
  return (
    <React.Fragment>
      <Navbar data={dataNav} />
      <PageBanner
        pageTitle="Categories"
        homePageUrl="/"
        homePageText="Home"
        activePageText="Categories"
      />

      <div className="categories-area pb-100">
        <div className="container">
          <div className="row">
            <div className="col-lg-3 col-sm-6 col-md-6 col-xs-6">
              <div className="single-categories-box">
                <img
                  src="https://www.deccanherald.com/sites/dh/files/styles/article_detail/public/article_images/2019/10/21/ias%204-1571657168.jpg"
                  className="w-fit"
                  alt="image"
                />

                <div className="content">
                  <h3>IAS</h3>
                  <span>10 Courses </span>
                </div>

                <Link href="/courses-1">
                  <a className="link-btn"></a>
                </Link>
              </div>
            </div>

            <div className="col-lg-3 col-sm-6 col-md-6 col-xs-6">
              <div className="single-categories-box">
                <img src="/images/categories/categorie2.jpg" alt="image" />

                <div className="content">
                  <h3>CSIR</h3>
                  <span>20 Courses</span>
                </div>

                <Link href="/courses-1">
                  <a className="link-btn"></a>
                </Link>
              </div>
            </div>

            <div className="col-lg-3 col-sm-6 col-md-6 col-xs-6">
              <div className="single-categories-box">
                <img src="/images/categories/categorie3.jpg" alt="image" />

                <div className="content">
                  <h3>IT & Software</h3>
                  <span>15 Courses</span>
                </div>

                <Link href="/courses-1">
                  <a className="link-btn"></a>
                </Link>
              </div>
            </div>

            <div className="col-lg-3 col-sm-6 col-md-6 col-xs-6">
              <div className="single-categories-box">
                <img src="/images/categories/categorie4.jpg" alt="image" />

                <div className="content">
                  <h3>Design</h3>
                  <span>11 Courses</span>
                </div>

                <Link href="/courses-1">
                  <a className="link-btn"></a>
                </Link>
              </div>
            </div>

            <div className="col-lg-3 col-sm-6 col-md-6 col-xs-6">
              <div className="single-categories-box">
                <img src="/images/categories/categorie5.jpg" alt="image" />

                <div className="content">
                  <h3>Lifestyle</h3>
                  <span>10 Courses</span>
                </div>

                <Link href="/courses-1">
                  <a className="link-btn"></a>
                </Link>
              </div>
            </div>

            <div className="col-lg-3 col-sm-6 col-md-6 col-xs-6">
              <div className="single-categories-box">
                <img src="/images/categories/categorie6.jpg" alt="image" />

                <div className="content">
                  <h3>Photo & Flim</h3>
                  <span>12 Courses</span>
                </div>

                <Link href="/courses-1">
                  <a className="link-btn"></a>
                </Link>
              </div>
            </div>

            <div className="col-lg-3 col-sm-6 col-md-6 col-xs-6">
              <div className="single-categories-box">
                <img src="/images/categories/categorie7.jpg" alt="image" />

                <div className="content">
                  <h3>Animation</h3>
                  <span>05 Courses</span>
                </div>

                <Link href="/courses-1">
                  <a className="link-btn"></a>
                </Link>
              </div>
            </div>

            <div className="col-lg-3 col-sm-6 col-md-6 col-xs-6">
              <div className="single-categories-box">
                <img src="/images/categories/categorie8.jpg" alt="image" />

                <div className="content">
                  <h3>Writing</h3>
                  <span>20 Courses</span>
                </div>

                <Link href="/courses-1">
                  <a className="link-btn"></a>
                </Link>
              </div>
            </div>

            <div className="col-lg-12 col-sm-12 col-md-12">
              <div className="pagination-area text-center">
                <a href="#" className="prev page-numbers">
                  <i className="bx bx-chevrons-left"></i>
                </a>
                <span className="page-numbers current" aria-current="page">
                  1
                </span>
                <a href="#" className="page-numbers">
                  2
                </a>
                <a href="#" className="page-numbers">
                  3
                </a>
                <a href="#" className="page-numbers">
                  4
                </a>
                <a href="#" className="next page-numbers">
                  <i className="bx bx-chevrons-right"></i>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="courses-area courses-section pt-20 pb-70">
        <div className="container">
          <div className="edemy-grid-sorting row align-items-center">
            <div className="col-lg-8 col-md-6 result-count">
              <p>
                We found <span className="count">12</span> courses available for
                you
              </p>
            </div>
          </div>

          <div className="flex gap-x-4 ">
            <div className="items-center flex-1">
              <div className="single-courses-box">
                <div className="courses-image">
                  <Link href="/product">
                    <a className="d-block image">
                      <img src="/images/product2.jpeg" alt="image" />
                    </a>
                  </Link>
                  <a href="#" className="fav">
                    <i className="flaticon-heart"></i>
                  </a>
                  <div className="price shadow">₹3900</div>
                </div>
                <div className="courses-content">
                  {/* <div className="course-author d-flex align-items-center">
                    <img
                      src="/images/user1.jpg"
                      className="rounded-circle"
                      alt="image"
                    />
                    <span>Alex Morgan</span>
                  </div> */}

                  <h3>
                    <Link href="/product">
                      <a>
                        The Data Science Course 2020: Complete Data Science
                        Bootcamp
                      </a>
                    </Link>
                  </h3>

                  <ul className="courses-box-footer d-flex justify-content-between align-items-center">
                    <li>
                      <i className="flaticon-agenda"></i> 15 Books
                    </li>
                    <li>
                      Rating{" "}
                      <span className="inline-flex rounded-full items-center py-0.5 pl-2.5 pr-1 text-sm font-medium bg-tn-green text-white">
                        4.9
                        <button
                          type="button"
                          className="flex-shrink-0 ml-0.5 h-4 w-4 rounded-full inline-flex items-center justify-center "
                        >
                          <span className="sr-only">Remove large option</span>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            className="h-5 w-5 text-white"
                            viewBox="0 0 20 20"
                            fill="currentColor"
                          >
                            <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"></path>
                          </svg>
                        </button>
                      </span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            <div className="items-center flex-1">
              <div className="single-courses-box">
                <div className="courses-image">
                  <Link href="/product">
                    <a className="d-block image">
                      <img src="/img/product_1.jpg" alt="image" />
                    </a>
                  </Link>
                  <a href="#" className="fav">
                    <i className="flaticon-heart"></i>
                  </a>
                  <div className="price shadow">₹49</div>
                </div>
                <div className="courses-content">
                  <div className="course-author d-flex align-items-center">
                    <img
                      src="/images/user2.jpg"
                      className="rounded-circle"
                      alt="image"
                    />
                    <span>Sarah Taylor</span>
                  </div>

                  <h3>
                    <Link href="/product">
                      <a>
                        Java Programming MasterclassName for Software Developers
                      </a>
                    </Link>
                  </h3>

                  <ul className="courses-box-footer d-flex justify-content-between align-items-center">
                    <li>
                      <i className="flaticon-agenda"></i> 20 Books
                    </li>
                    <li>
                      Rating{" "}
                      <span className="inline-flex rounded-full items-center py-0.5 pl-2.5 pr-1 text-sm font-medium bg-tn-green text-white">
                        4.9
                        <button
                          type="button"
                          className="flex-shrink-0 ml-0.5 h-4 w-4 rounded-full inline-flex items-center justify-center "
                        >
                          <span className="sr-only">Remove large option</span>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            className="h-5 w-5 text-white"
                            viewBox="0 0 20 20"
                            fill="currentColor"
                          >
                            <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"></path>
                          </svg>
                        </button>
                      </span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            <div className="items-center flex-1">
              <div className="single-courses-box">
                <div className="courses-image">
                  <Link href="/product">
                    <a className="d-block image">
                      <img src="/images/product3.jpeg" alt="image" />
                    </a>
                  </Link>
                  <a href="#" className="fav">
                    <i className="flaticon-heart"></i>
                  </a>
                  <div className="price shadow">₹59</div>
                </div>
                <div className="courses-content">
                  <div className="course-author d-flex align-items-center">
                    <img
                      src="/images/user3.jpg"
                      className="rounded-circle"
                      alt="image"
                    />
                    <span>David Warner</span>
                  </div>

                  <h3>
                    <Link href="/product">
                      <a>
                        Deep Learning A-Z™: Hands-On Artificial Neural Networks
                      </a>
                    </Link>
                  </h3>

                  <ul className="courses-box-footer d-flex justify-content-between align-items-center">
                    <li>
                      <i className="flaticon-agenda"></i> 20 Books
                    </li>
                    <li>
                      Rating{" "}
                      <span className="inline-flex rounded-full items-center py-0.5 pl-2.5 pr-1 text-sm font-medium bg-tn-green text-white">
                        4.9
                        <button
                          type="button"
                          className="flex-shrink-0 ml-0.5 h-4 w-4 rounded-full inline-flex items-center justify-center "
                        >
                          <span className="sr-only">Remove large option</span>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            className="h-5 w-5 text-white"
                            viewBox="0 0 20 20"
                            fill="currentColor"
                          >
                            <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"></path>
                          </svg>
                        </button>
                      </span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            <div className="items-center flex-1">
              <div className="single-courses-box">
                <div className="courses-image">
                  <Link href="/product">
                    <a className="d-block image">
                      <img src="/images/courses/courses15.jpg" alt="image" />
                    </a>
                  </Link>
                  <a href="#" className="fav">
                    <i className="flaticon-heart"></i>
                  </a>
                  <div className="price shadow">₹99</div>
                </div>
                <div className="courses-content">
                  <div className="course-author d-flex align-items-center">
                    <img
                      src="/images/user4.jpg"
                      className="rounded-circle"
                      alt="image"
                    />
                    <span>James Anderson</span>
                  </div>

                  <h3>
                    <Link href="/product">
                      <a>Learning A-Z™: Hands-On Python In Data Science</a>
                    </Link>
                  </h3>

                  <ul className="courses-box-footer d-flex justify-content-between align-items-center">
                    <li>
                      <i className="flaticon-agenda"></i> 44 Books
                    </li>
                    <li>
                      Rating{" "}
                      <span className="inline-flex rounded-full items-center py-0.5 pl-2.5 pr-1 text-sm font-medium bg-tn-green text-white">
                        4.9
                        <button
                          type="button"
                          className="flex-shrink-0 ml-0.5 h-4 w-4 rounded-full inline-flex items-center justify-center "
                        >
                          <span className="sr-only">Remove large option</span>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            className="h-5 w-5 text-white"
                            viewBox="0 0 20 20"
                            fill="currentColor"
                          >
                            <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"></path>
                          </svg>
                        </button>
                      </span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </React.Fragment>
  );
};

export default Categories;
